/** Maximum modules shown in visible nav section (before "More") */
export const MAX_VISIBLE_MODULES = 10;

/** Module states considered "active" for nav display */
export const ACTIVE_STATES: ReadonlySet<string> = new Set([
  'PUBLISHED',
  'DRAFT',
]);
